var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05654 23.057C6.53584 23.5777 6.53584 24.4219 7.05654 24.9426C7.57724 25.4633 8.42146 25.4633 8.94216 24.9426L15.9993 17.8855L23.0565 24.9426C23.5772 25.4633 24.4215 25.4633 24.9422 24.9426C25.4629 24.4219 25.4629 23.5777 24.9422 23.057L17.885 15.9998L24.9422 8.94265C25.4629 8.42195 25.4629 7.57773 24.9422 7.05703C24.4215 6.53633 23.5772 6.53633 23.0565 7.05703L15.9993 14.1142L8.94216 7.05703C8.42146 6.53633 7.57724 6.53633 7.05654 7.05703C6.53584 7.57773 6.53584 8.42195 7.05654 8.94265L14.1137 15.9998L7.05654 23.057Z",
    fill: "#1F3238"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.e8b8ca24feca4e04f70bd0064dd29452.svg";
export { ForwardRef as ReactComponent };